import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../shared/shared.module';
import { SidebarPanelComponent } from './sidebar-panel/sidebar-panel.component';
import { StateService } from '../shared/state/state.service';

@NgModule({
  imports: [
    SharedProviderModule,
  ],
  declarations: [SidebarPanelComponent],
  providers: [StateService],
  exports: [SidebarPanelComponent]
})
export class SidebarModule {
}
